/**
 * Formats an amount in cents into a localized money string using Shopify's
 * runtime money formatter when available, falling back to a plain USD format.
 */
export const formatMoney = (cents: number): string => {
  if (window.Shopify?.formatMoney) {
    return window.Shopify.formatMoney(cents, window.Shopify.money_format);
  }
  return `$${(cents / 100).toFixed(2)}`;
};
